import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ClockWidget as mainModule } from './main';
import * as $ from 'jquery';
import { init as mainTheme } from './themes/main';

declare var require: any;
require('../sass-main/pdc-widget-clock.sass');

export class ClockWidget extends WidgetBase {
    public static _name: string = 'Clock';
    public static moduleName: string = 'pdc-widget-clock';
    public static icon: string = 'time';
    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-clock'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ClockWidget);
